import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/customers/refunds/shipments'


const CustomerOrderRefundRequestReturnShipmentsApiV2 = {

  /**
   * Get list of Customer Refund  Shipments
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - Additional filter. It can be outside from ReactTable state
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },


  /**
   * create Customer Refund  Shipments
   * @param {object} values - FormikBag values
   * @param {array} refund_ids - collection of selected refund to be shipped
   * @param {number} shipping_address_id - selected shipping address
   */
  create: async ({
    values,
    refund_ids,
    shipping_address_id
  }) => {
    const payload = {
      refund_shipment: {
        ...values,
        shipping_address_id : shipping_address_id,
        customer_refund_ids : refund_ids
      }
    }

    const response = axios.post(API_PATH, payload)
    return response
  },

  /**
   * Show single Customer Refund Shipments
   * @param {number} id Customer Refund Shipment ID
   */
  show: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = axios.get(path)
    return response
  },

  /**
   * Ship the Customer Refund Shipments
   * @param {number} id Customer Refund Shipment ID
   * @param {object} values FormikBag value
   */
  ship: async ({ id, values }) => {
    const path    = `${API_PATH}/${id}/ship`
    const payload = {
      refund_shipment: values
    }

    const response = axios.patch(path, payload)
    return response
  }
}

export default CustomerOrderRefundRequestReturnShipmentsApiV2
